import React from 'react';
import PropTypes from 'prop-types';

import { onClickWrapper } from '../../../utils/ui';

const Arrow = ({ className, style, id, onClick, src }) => (
  <>
    {src ? (
      <img
        {...{ id, className, style, src }}
        alt="arrow"
        onClick={onClickWrapper(id, onClick)}
      />
    ) : (
      <div
        {...{ id, className, style }}
        alt="arrow"
        onClick={onClickWrapper(id, onClick)}
      />
    )}
  </>
);

Arrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string,
  onClick: PropTypes.func,
  src: PropTypes.string
};

export default Arrow;
